import { head } from '@soltalabs/ramda-extra'
import CSV from 'papaparse'
import React, { useRef } from 'react'
import { toast } from 'react-toastify'

import { JobService } from '../../../api/job'

import {
  ImportJobsContainer,
  ImportJobsButtonContainer,
  ImportJobsButton,
  AddIcon,
  ImportJobsLabel,
  TemplateLink,
} from './styles'

const onUploadJobs = (event) => {
  const selectedFile = head(event.target.files)
  if (!selectedFile) {
    toast.error(`Upload Failed: No file selected`)
    return
  }

  CSV.parse(selectedFile, {
    // We parse the file it to check if it's a CSV or not. Yes it's a hack, bite me.
    complete: () => {
      const formData = new FormData()
      formData.append('', selectedFile)

      JobService.upload(formData)
        .then((response) => response.json())
        .then((response) => {
          if (response.error) throw Error(response.message)
          toast.success('Upload Success')
        })
        .catch((error) => {
          toast.error(`Upload Failed: ${error}`)
        })
    },
    error: () => {
      toast.error(`Upload Failed: Invalid file format`)
    },
  })
}

const ImportJobsButtons = () => {
  const fileUploadRef = useRef(null)

  const openFileUpload = () => fileUploadRef.current.click()

  return (
    <ImportJobsContainer>
      <ImportJobsButtonContainer
        className="button-import-jobs"
        onClick={openFileUpload}
      >
        <ImportJobsButton>
          <input
            type="file"
            accept="csv"
            ref={fileUploadRef}
            onChange={onUploadJobs}
            style={{ display: 'none' }}
          />
          <AddIcon color="primary" fontSize="large" />
        </ImportJobsButton>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '12px',
          }}
        >
          <ImportJobsLabel>IMPORT JOBS</ImportJobsLabel>
          <TemplateLink
            className="link-download-template"
            href="/upload-template.csv"
            onClick={(event) => event.stopPropagation()}
          >
            Download template
          </TemplateLink>
        </div>
      </ImportJobsButtonContainer>
    </ImportJobsContainer>
  )
}

export { ImportJobsButtons }
